import type { FC } from 'react';
import AntEmpty from 'antd/es/empty';
import type { EmptyProps as AntEmptyProps } from 'antd/es/empty';
import { cn } from 'app/lib/utils';

export interface EmptyProps extends AntEmptyProps {}

const EmptyBase: FC<EmptyProps> = ({ className, ...rest }) => (
  <AntEmpty className={cn(className)} {...rest} />
);

// Empty-state façade over antd `Empty`; the image presets ride along so
// callers never need the antd import for them.
export const Empty = EmptyBase as typeof EmptyBase & {
  PRESENTED_IMAGE_DEFAULT: typeof AntEmpty.PRESENTED_IMAGE_DEFAULT;
  PRESENTED_IMAGE_SIMPLE: typeof AntEmpty.PRESENTED_IMAGE_SIMPLE;
};
Empty.PRESENTED_IMAGE_DEFAULT = AntEmpty.PRESENTED_IMAGE_DEFAULT;
Empty.PRESENTED_IMAGE_SIMPLE = AntEmpty.PRESENTED_IMAGE_SIMPLE;

export default Empty;
